import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../components/motion";
import { CTAPanel } from "../components/CTAPanel";
import { POSTS } from "../data/content";

export default function Blog() {
  return (
    <>
      <section className="pt-[72px] hero-grid-bg" data-testid="blog-hero">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-16 sm:pt-28 sm:pb-20">
          <Reveal>
            <p className="text-indigo font-semibold text-sm uppercase tracking-widest mb-4">Tips & guides</p>
            <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-ink max-w-3xl leading-[1.06]">
              Digital tips, minus the <span className="text-gradient">tech-speak</span>.
            </h1>
            <p className="mt-6 text-slate text-base sm:text-lg max-w-2xl leading-relaxed">
              Short, practical reads for busy small business owners. No jargon, no fluff — just things you can actually use.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-24" data-testid="blog-grid">
        <Stagger className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {POSTS.map((p) => (
            <StaggerItem key={p.slug}>
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group block h-full bg-white rounded-[2rem] border border-ink/5 shadow-sm hover:shadow-[0_24px_56px_rgba(20,22,46,0.1)] hover:-translate-y-1.5 transition-[box-shadow,transform] duration-300 p-8 sm:p-10"
              >
                <div className="flex items-center gap-3 mb-5">
                  <span className="text-[11px] font-semibold text-indigo bg-indigo/8 border border-indigo/15 rounded-full px-3 py-1">{p.tag}</span>
                  <span className="text-xs text-slate flex items-center gap-1.5"><Clock className="w-3 h-3" /> {p.readTime}</span>
                </div>
                <h2 className="font-display font-semibold text-ink text-xl sm:text-2xl leading-snug mb-3 group-hover:text-indigo transition-colors duration-200">
                  {p.title}
                </h2>
                <p className="text-slate text-sm leading-relaxed mb-6">{p.excerpt}</p>
                <span className="inline-flex items-center gap-2 text-indigo font-semibold text-sm group-hover:gap-3 transition-[gap] duration-300">
                  Read the guide <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <CTAPanel title="Rather we just handled it?" sub="Reading about digital is one thing. Having it done for you in a fortnight is better." />
    </>
  );
}
